/**
 * UranIA PA — Cutover announcement banner state (US-008 Fase 6).
 *
 * Zustand store in-memory che tiene il flag `dismissed` del banner
 * cutover sticky. Il dismiss è volatile (no `persist` middleware): un
 * refresh / nuova sessione riporta il banner a visibile finché il
 * cutover non è passato. La motivazione è simmetrica al banner AI Act
 * art. 50 (`banner-store.ts`): la comunicazione cutover è un avviso
 * "pre-cutover" che DEVE riapparire ad ogni sessione per assicurare che
 * tutti i funzionari attivi nei 7 gg precedenti abbiano visto l'avviso.
 *
 * Pattern allineato a `lib/ai-disclosure/banner-store.ts` (US-011).
 */

import { create } from 'zustand';

export interface CutoverAnnouncementBannerState {
  readonly dismissed: boolean;
  readonly dismiss: () => void;
  readonly reset: () => void;
}

export const useCutoverAnnouncementBannerStore = create<CutoverAnnouncementBannerState>((set) => ({
  dismissed: false,
  dismiss: (): void => {
    set({ dismissed: true });
  },
  reset: (): void => {
    set({ dismissed: false });
  },
}));

export const selectCutoverAnnouncementDismissed = (
  state: CutoverAnnouncementBannerState,
): boolean => state.dismissed;
